var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "8 8 24 24",
    enableBackground: "new 8 8 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,8C13.372,8,8,13.372,8,20s5.372,12,12,12s12-5.372,12-12S26.628,8,20,8z M20,10.667 c5.154,0,9.333,4.179,9.333,9.333c0,0.768-0.103,1.509-0.276,2.222h-6.827l4.514-6.565l-2.197-1.51l-5.553,8.075h-8.049 c-0.175-0.713-0.277-1.454-0.277-2.222C10.667,14.846,14.846,10.667,20,10.667z M20,29.333c-3.359,0-6.296-1.78-7.939-4.444h8.172 l0.111,0.077l0.053-0.077h7.543C26.296,27.553,23.359,29.333,20,29.333z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/meter.9e0e5ff76044c97acb708ae2e0120d50.svg";
export { ForwardRef as ReactComponent };